import { TranslateService } from '@ngx-translate/core';
import { Facet } from '@app/shared/models/core-api.model';
import { Filter } from '@app/shared/components/filter/filter.component';

export function makeFacetConfig(facets: Facet[], translate: TranslateService) {
  const facetConfigs = [];

  facets.forEach((facet) => {
    facetConfigs.push({
      showEmptyOptions: true,
      id: facet.id,
      title: translate.instant(`Attributes_${facet.id}`),
    });
    facet.values = facet.values.map((value) => {
      return {
        ...value,
        name: translate.instant(`Attributes_${value.id}`),
      };
    });
  });

  return { facets, facetConfigs };
}

export function getEnabledFacets(filters: Filter[]) {
  const enabledFacetValues = (filter: Filter) =>
    filter.filters[0].subitems.filter((x) => x.isSelected);

  const enabledFacets = [];

  filters.forEach((filter) => {
    const enabledValues = enabledFacetValues(filter);

    if (enabledValues.length) {
      enabledFacets.push({
        id: filter.id,
        values: enabledValues.map((x) => x.model.id),
      });
    }
  });

  return enabledFacets;
}
